export const setAdrumConfig = (adrumKey, thousandEyesHeader) => {
  window['adrum-start-time'] = new Date().getTime();
  (function (config) {
    config.userEventInfo = {
      PageView: function () {
        return {
          userData: {
            thousandEyesHeader: thousandEyesHeader
          }
        };
      },
      Ajax: function () {
        return {
          userData: {
            thousandEyesHeader: thousandEyesHeader
          }
        };
      }
    };
    config.appKey = adrumKey;
    config.adrumExtUrlHttps = 'https://cdn.appdynamics.com';
    config.beaconUrlHttps = 'https://col.eum-appdynamics.com';
    // fetch + isZonePromise enabled fixes issue with AppD/Dexie incompatibility
    config.fetch = true;
    // fetch + isZonePromise enabled fixes issue with AppD/Dexie incompatibility
    config.isZonePromise = true;
    config.resTiming = { bufSize: 200, clearResTimingOnBeaconSend: true };
    config.spa = { spa2: true };
    config.useHTTPSAlways = true;
    config.xd = { enable: false };
  })(window['adrum-config'] || (window['adrum-config'] = {}));
};

export const clearAdrumCookies = () => {
  document.cookie = 'ADRUM=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
  document.cookie =
    'ADRUM_BT1=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
  document.cookie =
    'ADRUM_BTa=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
  document.cookie = 'ADRUM_BTs; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
  document.cookie =
    'ADRUM_BTg=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
  document.cookie =
    'ADRUM_BTh=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
};
